import { render, staticRenderFns } from "./ODashboardMenu.vue?vue&type=template&id=574b00ac"
import script from "./ODashboardMenu.vue?vue&type=script&lang=js"
export * from "./ODashboardMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports